/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_A5Inputs */

const en_to_csv_faq_a5 = /** @type {(inputs: To_Csv_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. A nested object arrives in one cell as JSON text. Flatten the structure in your own code first if you want each nested field as its own column.`)
};

const ko_to_csv_faq_a5 = /** @type {(inputs: To_Csv_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 중첩 객체는 JSON 텍스트로 한 칸에 도착합니다. 중첩 필드마다 열을 원한다면 먼저 코드에서 구조를 펼치세요.`)
};

const ja_to_csv_faq_a5 = /** @type {(inputs: To_Csv_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。ネストしたオブジェクトは JSON テキストとして 1 つのセルに届きます。ネストした各フィールドを列にしたいなら、先に自分のコードで構造を平坦化してください。`)
};

/**
* | output |
* | --- |
* | "No. A nested object arrives in one cell as JSON text. Flatten the structure in your own code first if you want each nested field as its own column." |
*
* @param {To_Csv_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_a5 = /** @type {((inputs?: To_Csv_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_a5(inputs)
	if (locale === "ko") return ko_to_csv_faq_a5(inputs)
	return ja_to_csv_faq_a5(inputs)
});